export default __webpack_public_path__ + "static/media/020-compass-2.6d5cbc16.png";